<template>
  <div class="flex flex-column gap-3">
    <export-modal :visible.sync="visibleExportModal" initial-section="write_ups" />
    <div class="flex justify-content-between align-items-start">
      <h3 class="m-0">Disciplinary</h3>
      <uncompleted-task-action />
    </div>

    <div class="flex justify-content-between align-items-start">
      <a-radio-group
        v-model="activeView"
        class="profile-disciplinary-view-switcher w-full"
        button-style="solid"
        data-testid="associate-profiles-filter-completion-status-radio"
      >
        <a-radio-button
          class="flex-1 p-0 text-center"
          v-for="item in viewOptions"
          :key="item.value"
          :value="item.value"
        >
          {{ item.label }}
        </a-radio-button>
      </a-radio-group>
    </div>

    <div class="flex gap-2">
      <p>Violation History: </p>
      <history-tags
        v-if="activeView === 'all'"
        class="align-self-center"
        :history-data="associate.reviewed_violation_history"
        data-testid="profile-disciplinary-reviewed-history"
      />
    </div>

    <disciplinary-actions-table
      v-if="activeView === 'all'"
      :associate-id="associate.id"
      :show-associate-column="false"
      :show-header="false"
      :associate-profile-export="true"
      @export="visibleExportModal = true"
    >
      <template #actions>
        <div
          v-if="hasUncontrolledPermission('manage_associates', { id: associate.id })"
          class="flex flex-wrap gap-2"
          data-testid="profile-disciplinary-all-actions"
        >
          <a-button
            :disabled="!associate.is_active || !!associate.suspension"
            type="primary"
            @click="openCreation('block', 'block')"
          >
            Block
          </a-button>
          <a-button type="primary" @click="openCreation('suspensions', 'suspensions')"> Penalize </a-button>
          <a-button type="primary" @click="openCreation('write-ups', 'writeUps')"> Create Written Warning </a-button>
        </div>
      </template>
    </disciplinary-actions-table>
    <suspension-info v-if="activeView === 'block' && associate.is_active" ref="block" />
    <profile-authorizations v-if="activeView === 'authorizations'" />
    <profile-shift-penalty v-if="activeView === 'suspensions'" ref="suspensions" />
    <profile-write-up v-if="activeView === 'write-ups'" ref="writeUps" @export="visibleExportModal = true" />
  </div>
</template>

<script>
import { Button, Radio } from 'ant-design-vue'
import ProfileSuspensionInfo from './profile-suspension-info.vue'
import ProfileViewAuthorizations from './profile-view-authorizations.vue'
import { createNamespacedHelpers } from 'vuex'
import ProfileViewWriteUp from './profile-view-write-up.vue'
import ShiftPenalty from './shift-penalty/shift-penalty.vue'
import ProfileUncompletedTaskAction from './profile-uncompleted-task-action.vue'
import DisciplinaryActionsTable from '@/modules/disciplinary/components/disciplinary-actions-table.vue'
import AuthHistoryTags from '@/modules/authorizations/components/shift-auth-history.vue'
import permissionMixin from '@/mixins/permissionMixin'
import ProfileViewExport from './profile-view-export.vue'

const { mapState: profileState } = createNamespacedHelpers('profile')

export default {
  components: {
    'a-button': Button,
    'a-radio-group': Radio.Group,
    'a-radio-button': Radio.Button,
    'suspension-info': ProfileSuspensionInfo,
    'profile-authorizations': ProfileViewAuthorizations,
    'profile-write-up': ProfileViewWriteUp,
    'profile-shift-penalty': ShiftPenalty,
    'uncompleted-task-action': ProfileUncompletedTaskAction,
    'history-tags': AuthHistoryTags,
    'disciplinary-actions-table': DisciplinaryActionsTable,
    'export-modal': ProfileViewExport
  },
  mixins: [permissionMixin],
  data() {
    return {
      activeView: 'all',
      visibleExportModal: false,
      viewOptions: [
        { value: 'all', label: 'All' },
        { value: 'authorizations', label: 'Violations' },
        { value: 'block', label: 'Block' },
        { value: 'suspensions', label: 'Suspensions' },
        { value: 'write-ups', label: 'Written Warnings' }
      ]
    }
  },
  computed: {
    ...profileState({
      associate: state => state.associate
    })
  },
  methods: {
    openCreation(view, ref) {
      this.activeView = view
      this.$nextTick(() => this.$refs[ref]?.openCreate())
    }
  }
}
</script>

<style scoped>
.profile-disciplinary-view-switcher {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
</style>
